import { Button, Switch, Typography } from '@mui/material'
import { useAppServices } from 'hook/services';
import { useAgencyInfo } from 'context/agency';
import React, { useEffect } from 'react'

const BespokeIntegrations = ({ formData, handleRefresh }) => {
    const Service = useAppServices();
    const url = window.location.href;
    const parts = url.split('/');
    const lastPart = parts[parts.length - 1];
    const [integrations, setIntegrations] = React.useState([]);
    const [agency] = useAgencyInfo()
    const [activeIntegrations, setActiveIntegrations] = React.useState(formData?.active_integrations || []);
    const [loading, setLoading] = React.useState(false);
    const getIntegrations = async () => {
        const { response } = await Service.integrations.availableBranding({ query: `agency_id=${agency?._id}` });
        if (response?.success) {
            setIntegrations(response.data);
        }
    }

    useEffect(() => {
        if (formData?.active_integrations && agency?._id)
            setActiveIntegrations(formData?.active_integrations)
    }, [formData, agency])

    const updateAccounts = async () => {
        setLoading(true);
        const payload = {
            active_integrations: activeIntegrations,
            id: lastPart
        }
        const { response } = await Service.accounts.updateAccount({ payload });
        if (response?.success) {
            handleRefresh();
            setLoading(false);
        } else {
            setLoading(false);
            alert("Failed to update integrations")
        }
    }

    useEffect(() => {
        getIntegrations();
    }, [])

    return (
        <div style={{ display: "block" }}>
            {Object.keys(formData)?.length > 0 && integrations?.map((integration, index) => (
                <div key={index} style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "8px", alignItems: "center" }}>
                    <Typography sx={{ textTransform: "capitalize", fontSize: "18px" }}>
                        {integration?.display_name}
                    </Typography>
                    <Switch checked={activeIntegrations.includes(integration?.provider)} onChange={() => setActiveIntegrations((prev) => {
                        if (prev.includes(integration?.provider)) {
                            return prev.filter((id) => id !== integration?.provider);
                        }
                        return [...prev, integration?.provider];
                    })} />
                </div>
            ))}
            <div style={{
                display: "flex", width: "100%", justifyContent: "end", marginTop: "12px"
            }}>
                <Button
                    onClick={updateAccounts}
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: "10px" }}
                >
                    save
                </Button>
            </div>
        </div>
    )
}

export default BespokeIntegrations